import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=6be446a4&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be446a4",
  null
  
)

export default component.exports